import { defineComponent, ref, computed } from 'vue'
import { Tabs as VanTabs, Tab as VanTab } from 'vant'
import { getBallColor, getZodiac, getZodiacYear, getWuxing } from '@/utils/lottery-attr'
import type { BallColor } from '@/components/lottery-ball-row'

interface TabDef {
  name: string
  value: string
}

const TAB_LIST: TabDef[] = [
  { name: '波色', value: 'wrap1' },
  { name: '生肖', value: 'wrap2' },
  { name: '五行', value: 'wrap3' },
  { name: '家禽野兽', value: 'wrap4' },
  { name: '男女生肖', value: 'wrap5' },
  { name: '天地生肖', value: 'wrap6' },
  { name: '四季生肖', value: 'wrap7' },
  { name: '琴棋书画', value: 'wrap8' },
  { name: '三色生肖', value: 'wrap9' },
  { name: '生肖对冲', value: 'wrap10' },
  { name: '前肖后肖', value: 'wrap11' },
  { name: '吉美凶丑', value: 'wrap12' },
  { name: '左肖右肖', value: 'wrap13' },
  { name: '黑肖白肖', value: 'wrap14' },
  { name: '阴肖阳肖', value: 'wrap15' },
  { name: '胆大小', value: 'wrap16' },
  { name: '日肖夜肖', value: 'wrap17' },
  { name: '单双笔', value: 'wrap18' },
  { name: '肉菜草肖', value: 'wrap19' },
  { name: '风雨雷电', value: 'wrap20' },
]

const ZODIACS = ['鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊', '猴', '鸡', '狗', '猪']

// 生肖对冲:横向 3 行 6 列(对应 49208 chunk-attribute.js dealData 中 w[0]/w[1]/w[2])
const DUICHONG_ROWS: string[][] = [
  ['鼠', '兔', '蛇', '龙', '牛', '虎'],
  ['冲', '冲', '冲', '冲', '冲', '冲'],
  ['马', '鸡', '猪', '狗', '羊', '猴'],
]

// 各 wrap2-4 类型的生肖分组(从 ef811e2 旧版本恢复)
type ZodiacGroup = { name: string; list: string[] }
const ZODIAC_CATEGORIES: Record<string, ZodiacGroup[]> = {
  wrap4: [
    { name: '家禽', list: ['牛', '马', '羊', '鸡', '狗', '猪'] },
    { name: '野兽', list: ['鼠', '虎', '兔', '龙', '蛇', '猴'] },
  ],
  wrap5: [
    { name: '男肖', list: ['鼠', '牛', '虎', '龙', '马', '猴', '狗'] },
    { name: '女肖', list: ['兔', '蛇', '羊', '鸡', '猪'] },
  ],
  wrap6: [
    { name: '天肖', list: ['牛', '兔', '龙', '马', '猴', '猪'] },
    { name: '地肖', list: ['鼠', '虎', '蛇', '羊', '鸡', '狗'] },
  ],
  wrap7: [
    { name: '春肖', list: ['虎', '兔', '龙'] },
    { name: '夏肖', list: ['蛇', '马', '羊'] },
    { name: '秋肖', list: ['猴', '鸡', '狗'] },
    { name: '冬肖', list: ['鼠', '牛', '猪'] },
  ],
  wrap8: [
    { name: '琴肖', list: ['兔', '蛇', '鸡'] },
    { name: '棋肖', list: ['鼠', '牛', '狗'] },
    { name: '书肖', list: ['虎', '龙', '马'] },
    { name: '画肖', list: ['羊', '猴', '猪'] },
  ],
  wrap9: [
    { name: '红肖', list: ['鼠', '兔', '马', '鸡'] },
    { name: '蓝肖', list: ['虎', '蛇', '猴', '猪'] },
    { name: '绿肖', list: ['牛', '龙', '羊', '狗'] },
  ],
  wrap11: [
    { name: '前肖', list: ['鼠', '牛', '虎', '兔', '龙', '蛇'] },
    { name: '后肖', list: ['马', '羊', '猴', '鸡', '狗', '猪'] },
  ],
  wrap12: [
    { name: '吉美', list: ['兔', '龙', '蛇', '马', '羊', '鸡'] },
    { name: '凶丑', list: ['鼠', '牛', '虎', '猴', '狗', '猪'] },
  ],
  wrap13: [
    { name: '左肖', list: ['鼠', '牛', '龙', '蛇', '猴', '鸡'] },
    { name: '右肖', list: ['虎', '兔', '马', '羊', '狗', '猪'] },
  ],
  wrap14: [
    { name: '黑肖', list: ['兔', '龙', '蛇', '马', '羊', '猴'] },
    { name: '白肖', list: ['鼠', '牛', '虎', '鸡', '狗', '猪'] },
  ],
  wrap15: [
    { name: '阴肖', list: ['鼠', '龙', '蛇', '马', '狗', '猪'] },
    { name: '阳肖', list: ['牛', '虎', '兔', '羊', '猴', '鸡'] },
  ],
  wrap16: [
    { name: '胆大', list: ['牛', '虎', '马', '猴', '狗', '猪'] },
    { name: '胆小', list: ['鼠', '兔', '龙', '蛇', '羊', '鸡'] },
  ],
  wrap17: [
    { name: '日肖', list: ['兔', '龙', '蛇', '马', '羊', '猴'] },
    { name: '夜肖', list: ['鼠', '牛', '虎', '鸡', '狗', '猪'] },
  ],
  wrap18: [
    { name: '单笔', list: ['鼠', '龙', '马', '蛇', '鸡', '猪'] },
    { name: '双笔', list: ['虎', '猴', '狗', '兔', '羊', '牛'] },
  ],
  wrap19: [
    { name: '肉肖', list: ['虎', '蛇', '龙', '狗'] },
    { name: '菜肖', list: ['猪', '鼠', '鸡', '猴'] },
    { name: '草肖', list: ['牛', '羊', '马', '兔'] },
  ],
  wrap20: [
    { name: '风肖', list: ['虎', '兔', '龙'] },
    { name: '雨肖', list: ['蛇', '马', '羊'] },
    { name: '雷肖', list: ['猴', '鸡', '狗'] },
    { name: '电肖', list: ['鼠', '牛', '猪'] },
  ],
}

interface BallItem {
  number: number
  color: BallColor
}

function ballColorClass(c: BallColor) {
  if (c === 'green') return 'green'
  if (c === 'blue') return 'blue'
  return 'red'
}

export default defineComponent({
  name: 'AttributeRefPage',
  setup() {
    const tab2 = ref('wrap1')
    const zodiacYear = computed(() => getZodiacYear(new Date()))

    // 1-49 全号码列表
    const allNumbers = computed<BallItem[]>(() =>
      Array.from({ length: 49 }, (_, i) => {
        const number = i + 1
        return { number, color: getBallColor(number) }
      }),
    )

    // wrap1 波色
    const colorGroups = computed(() => {
      const groups: { name: string; list: BallItem[] }[] = [
        { name: '红波', list: [] },
        { name: '蓝波', list: [] },
        { name: '绿波', list: [] },
      ]
      for (const b of allNumbers.value) {
        if (b.color === 'red') groups[0]!.list.push(b)
        else if (b.color === 'blue') groups[1]!.list.push(b)
        else if (b.color === 'green') groups[2]!.list.push(b)
      }
      return groups
    })

    // wrap2 生肖
    const zodiacGroups = computed(() => {
      const map = new Map<string, BallItem[]>()
      for (const z of ZODIACS) map.set(z, [])
      for (const b of allNumbers.value) {
        const z = getZodiac(zodiacYear.value, b.number)
        map.get(z)?.push(b)
      }
      return ZODIACS.map((name) => ({ name, list: map.get(name) ?? [] }))
    })

    // wrap3 五行
    const wuxingGroups = computed(() => {
      const map = new Map<string, BallItem[]>()
      for (const k of ['金', '木', '水', '火', '土']) map.set(k, [])
      for (const b of allNumbers.value) {
        const w = getWuxing(zodiacYear.value, b.number)
        map.get(w)?.push(b)
      }
      return [...map.entries()].map(([name, list]) => ({ name, list }))
    })

    /** 带标题的号码分组（波色、五行）：每组一个 h4 + 号码球 */
    const renderTitledGroups = (wrapClass: string, groups: typeof colorGroups.value) => (
      <div class={['container-wrap', wrapClass]}>
        {groups.map((g) => (
          <div class="container2-wrap" key={g.name}>
            <h4>{g.name}</h4>
            <div class="color-wrap span-wrap">
              {g.list.map((b) => (
                <div key={b.number}>
                  <span class={ballColorClass(b.color)}>{String(b.number).padStart(2, '0')}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    )

    return () => (
      <div class="mint-tab-container-wrap">
        <div class="mint-tab-container-item">
          <VanTabs
            v-model:active={tab2.value}
            color="#07c160"
            titleActiveColor="#07c160"
            scrollspy={false}
            swipeable={false}
          >
            {TAB_LIST.map((t) => (
              <VanTab key={t.value} name={t.value} title={t.name} />
            ))}
          </VanTabs>

          {/* wrap1:波色 */}
          {tab2.value === 'wrap1' && renderTitledGroups('wrap2-1', colorGroups.value)}

          {/* wrap2:生肖 */}
          {tab2.value === 'wrap2' && (
            <div class="container-wrap wrap2-2">
              {zodiacGroups.value.map((g) => (
                <div class="container2-wrap" key={g.name}>
                  <div class="color-wrap span-wrap">
                    <i>{g.name}</i>
                    {g.list.map((b) => (
                      <div key={b.number}>
                        <span class={ballColorClass(b.color)}>
                          {String(b.number).padStart(2, '0')}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* wrap3:五行 */}
          {tab2.value === 'wrap3' && renderTitledGroups('wrap2-3', wuxingGroups.value)}

          {/* wrap10:生肖对冲(横向 3 行 6 列,与 49208 dealData 输出一致) */}
          {tab2.value === 'wrap10' && (
            <div class="container-wrap wrap2-4">
              {DUICHONG_ROWS.map((row) => (
                <div class="container2-wrap block" key={row.join('')}>
                  <div class="animal">
                    <span></span>
                    {row.map((s, n) => (
                      <span key={`${s}${n}`}>{n === 0 ? s : '丶' + s}</span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* wrap4-9, 11-20:生肖分组(name + 生肖名列表,wrap2-4 布局) */}
          {ZODIAC_CATEGORIES[tab2.value] && (
            <div class="container-wrap wrap2-4">
              {ZODIAC_CATEGORIES[tab2.value]!.map((g) => (
                <div class="container2-wrap block" key={g.name}>
                  <div class="animal">
                    <span>{g.name}</span>
                    {g.list.map((s, n) => (
                      <span key={s}>{n === 0 ? s : '丶' + s}</span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    )
  },
})
